// extracted by mini-css-extract-plugin
module.exports = {"main":"docview-lite_main__SnmAB"};